// @flow
import * as React from 'react';
import {useParams} from "react-router-dom";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";


import {useNavigate} from "react-router-dom";
import {RiHeart3Fill, RiHeart3Line} from "react-icons/ri";


import {FaCubes} from "react-icons/fa";


export default function VendorInfo() {
    const navigate = useNavigate();
    const {id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [vendor, setVendor] = React.useState([]);


    React.useEffect(() => {

        let params = { };


        API.getVendor(id, params)
            .then((response) => {
                setVendor(response.data);

                setIsLoaded(true);
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },400)
    }, [id]);




    const favorite = () => {
        const params = {}
        API.favoriteVendor(id, params)
            .then((response) => {
                toast.success(response.message);
                API.getVendor(id, params)
                    .then((response) => {
                        setVendor(response.data);

                    })
                    .catch((error) => {
                        if (error.response) {
                            toast.error(error.response.data.message);
                        } else {
                            toast.error(error.message);
                        }
                    });
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header hasBack={true} transparent={true}/>
            <section className="container-fluid   rtl px-0 mx-0 products-list ">
                <div className="row mx-0 px-0">
                    <div className="col-12 px-0 bg-white">
                        <img src={vendor.cover_photo} alt={vendor.title}
                             className='w-100 company-cover-photo'/>

                    </div>
                </div>
                <div className="row mx-1 mt-2 mx-2">
                    <div className="col-6 text-end mt-2 fw-bold">
                        {vendor.title}
                    </div>
                    <div className="col-6 text-start text-big-2 mt-1 text-dark">
                        <span onClick={favorite}>
                                {
                                    vendor.is_favorite ?
                                        <RiHeart3Fill className='ms-3 text-danger'/> :
                                        <RiHeart3Line className='ms-3'/>
                                }
                        </span>

                        <FaCubes className='text-dark'
                                 onClick={() =>
                                     navigate(`/vendor/${id}/`)
                                 }
                        />
                    </div>

                </div>


                <div className="row vendor-container mx-2 p-2 mt-4">
                    <div className="col-12 text-center my-3">
                        <img src={vendor.image} alt={vendor.title} className='w-50' />
                    </div>
                    <div className="pe-2 col-12 text-small-1 text-justify ">

                        <p  dangerouslySetInnerHTML={{ __html: vendor.description }}></p>
                    </div>
                </div>
            </section>



            <div className='py-5'>
                &nbsp;
            </div>
        </React.Fragment>
    );
}